module.exports = __webpack_public_path__ + "img/VOTERID.d9a59eab.png";